const SECTION_ID = 'form-section';
const SUBSCRIBE_SECTION_CLASS = 'home-subscribe';
const ACTIVE_CLASS = 'home-subscribe--active';
const ARROW_BUTTON_CLASS = 'home-subscribe__heading';
const FORM_ID = 'home-subscription-form';
const SUBSCRIBE_BOX_CLASS = 'subscribe-box';
const INPUT_ACTIVE_CLASS = 'subscribe-box--active';
const INVALID_CLASS = 'subscribe-box--invalid';

class HomeSubscribeSection {
    constructor() {
        this._section = document.getElementById(SECTION_ID);
        if (this._section) {
            this._arrowButton = this._section.querySelector(`.${ARROW_BUTTON_CLASS}`);
            this._subscribeSection = this._section.querySelector(`.${SUBSCRIBE_SECTION_CLASS}`);
        }
        this._form = document.getElementById(FORM_ID);
        this._form && this._run();
    }
    _run = () => {
        this._input = this._form.querySelector('input');
        this._submitButton = this._form.querySelector('button');
        this._subscribeBox = this._form.querySelector(`.${SUBSCRIBE_BOX_CLASS}`);
        this._emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

        if (this._arrowButton) {
            this._arrowButton.addEventListener('click', this._activateSection);
        }
        if (location.hash === `#${SECTION_ID}`) {
            this._activateSection();
        }
    };
    _activateSection = () => {
        if (this._subscribeSection) {
            this._subscribeSection.classList.toggle(ACTIVE_CLASS);
        }
    };
}
const homeSubscribeSection = new HomeSubscribeSection();
